import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Map, fromJS} from "immutable";
import * as actions from '../../actions';
import * as srv from '../../services';
import moment from 'moment';
import {Menu, Icon, Dropdown, Badge, Button, Avatar, Spin} from 'antd';
import {parseUsername, parseAvatarText, parseTimeFromNow} from '../schedule/util';


class Notification extends Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false,
            loadingMore: false,
            loadingReadAll: false,
            notiState: [],
            notiLimit: 5,
            cantPushNoti: true,
            layoutPointer: true,
            notifications: Map({}),
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.notifications !== nextProps.notifications) {
            let notiState = [];
            let notifications = Map({});

            nextProps.notifications.map((noti) => {
                notifications = notifications.set(noti.iD.toString(), fromJS(noti));

                if (!noti.state) {
                    notiState.push(`${noti.iD}#${noti.issueID}`);
                }
            });

            notifications = notifications.sort(function (noti, nextNoti) {
                if (noti.get('unixTime') && nextNoti.get('unixTime')) {
                    return nextNoti.get('unixTime') - noti.get('unixTime');
                }

                return -1;
            });

            this.setState({notiState, notifications});
        }
    }

    async getNotification(limit) {
        let now = moment();
        let strNow = now.format('DD-MM-YYYY');
        const dataIssues = await srv.getAllIssues(63, this.props.token, 'week', strNow, limit);
        if (dataIssues.status === 401) {
            alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
            this.props.dispatch(actions.removeToken());
        }

        this.props.dispatch(actions.setNotis(dataIssues.notifications ? dataIssues.notifications : []));

        this.setState({
            loadingMore: false
        });
    }

    parseNotiHeader(fullName, noti) {
        switch (noti.type) {
            case 'issue-assigned-remove':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>{fullName}
                    </strong>đã xoá bạn khỏi lịch
                    <strong style={{padding: '0 4px'}}>
                        #{noti.issueID}
                    </strong>
                </span>
            case 'issue-assigned':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>{fullName}
                    </strong>đã gán bạn vào lịch
                    <strong style={{padding: '0 4px'}}>
                        #{noti.issueID}
                    </strong>
                </span>

            case 'issue-new':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>{fullName}
                    </strong> đã thêm lịch mới
                    <strong style={{padding: '0 4px'}}>
                        #{noti.issueID}
                    </strong>
                </span>

            case 'comment':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>{fullName}
                    </strong> đã bình luận trong
                    <strong style={{padding: '0 4px'}}>
                        #{noti.issueID} {noti.username ? noti.username : ''}
                    </strong>
                </span>

            case 'mention':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>{fullName}
                    </strong> đã nhắc đến bạn trong
                    <strong style={{padding: '0 4px'}}>
                        #{noti.issueID} {noti.username ? noti.username : ''}
                    </strong>
                </span>

            case 'sms-success':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>
                        Tin nhắn đã gửi thành công
                    </strong>
                </span>

            case 'sms-alert':
                return <span>
                    <strong
                        style={{
                            textTransform: 'capitalize',
                            padding: '0 4px'
                        }}>
                        Tin nhắn gửi không thành công
                    </strong>
                </span>
        }

        return '';
    }

    async setStateNoti(notiID) {
        const dataNoti = await srv.setStateNoti(notiID, this.props.token);

        if (dataNoti.status === 401) {
            alert("Đã hết phiên làm việc, vui lòng đăng nhập lại!");
            this.props.dispatch(actions.removeToken());
        }

        this.setState({
            loadingReadAll: false,
        });
    }

    alertIcon(noti) {
        if (noti.type === 'sms-success') {
            return <Icon
                style={{
                    top: '12px',
                    position: 'relative',
                    fontSize: '32px',
                    color: '#00a854'
                }}
                type="check-circle-o"
            />;
        }

        return <Icon
            style={{
                top: '12px',
                position: 'relative',
                fontSize: '32px',
                color: '#ffbf00'
            }}
            type="exclamation-circle-o"
        />;
    }

    parseNotiContent(noti) {
        if (noti.type === 'issue-new' && noti.issueID) {
            let issueFromJS = this.props.issuesMap.get(noti.issueID.toString());

            if (issueFromJS) {
                let issue = issueFromJS.toJS();

                let nowDate = moment().format('YYYY-MM-DD');
                let startDate = moment(issue.startDate).format('YYYY-MM-DD');
                let dateTimeString = `${startDate} ${issue.startTime}`;

                if (nowDate === startDate) {
                    let timeCalendar = moment(dateTimeString).calendar();

                    return <span>
                                <p style={{color: '#ff0000b3'}}>
                                    {timeCalendar}
                                </p>
                                <p>
                                    {noti.content}
                                </p>
                            </span>;
                } else {
                    return <span>
                                <p>
                                    {dateTimeString}
                                </p>
                                <p>
                                    {noti.content}
                                </p>
                            </span>;
                }

            }
        }

        return noti.content;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!this.state.notifications.equals(nextState.notifications)) {
            return true;
        }

        if (this.state.notiState.length !== nextState.notiState.length) {
            return true;
        }

        if (this.props.notiCount !== nextProps.notiCount) {
            return true;
        }

        if (this.state.visible !== nextState.visible) {
            return true;
        }

        if (this.state.loadingMore !== nextState.loadingMore) {
            return true;
        }

        if (this.state.loadingReadAll !== nextState.loadingReadAll) {
            return true;
        }

        return false;
    }

    render() {
        let notiIndex = 0;

        const notiView = (
            <Menu
                selectable={false}
                multiple={true}
                className={'dropdown-notification'}
                selectedKeys={this.state.notiState}
                onClick={(event) => {
                    if (event.key === 'more') {
                        let limit = this.state.notiLimit + 5;

                        this.getNotification(limit);

                        this.props.handleChangeState(limit, 'notiLimit');

                        this.setState({
                            loadingMore: true,
                            visible: true,
                            notiLimit: limit
                        });
                    } else if (event.key === 'read-all') {
                        this.setStateNoti('all');
                        this.setState({
                            loadingReadAll: true,
                            visible: true
                        });
                    } else {
                        let arrKey = event.key.split('#');

                        if (arrKey.length === 2) {
                            this.props.handleChangeState(arrKey[1], 'curIssueID');

                            this.setStateNoti(arrKey[0]);
                            this.setState({
                                visible: false,
                                layoutPointer: true
                            });
                        }
                    }
                }}
                style={{
                    width: '550px',
                    height: '396px',
                    overflow: 'auto',
                    overflowX: 'hidden',
                }}>
                <Menu.ItemGroup key="group-info">
                    <Menu.Item key="more">
                        <Spin size="small" spinning={this.state.loadingMore}>
                            <a style={{
                                float: 'left',
                                paddingTop: '3px',
                                paddingLeft: '5px',
                                paddingRight: '5px',
                                color: '#108ee9'
                            }}>Xem thêm</a>
                        </Spin>
                    </Menu.Item>
                    <Menu.Item key="read-all">
                        <Spin size="small" spinning={this.state.loadingReadAll}>
                            <a style={{
                                float: 'right',
                                paddingTop: '3px',
                                paddingLeft: '5px',
                                paddingRight: '5px',
                                color: '#108ee9'
                            }}>Đánh dấu tất cả đã đọc</a>
                        </Spin>
                    </Menu.Item>
                </Menu.ItemGroup>
                {
                    this.state.notifications && this.state.notifications.size > 0 ?
                        this.state.notifications.map((notiMap) => {
                            let noti = notiMap.toJS();
                            let user = this.props.usersMap.get(noti.from > 0 ? noti.from.toString() : 0);
                            let fullName = '';
                            let userColor = '#ccc';
                            if (user) {
                                fullName = parseUsername(user.get('firstname'), user.get('lastname'));
                                userColor = user.get('color');
                            }

                            notiIndex++;

                            return <Menu.Item
                                className={notiIndex === 1 ? 'noti-item-first' : ''}
                                key={`${noti.iD}#${noti.issueID}`}>

                                {
                                    noti.from > 0 ?
                                        <Avatar style={{
                                            backgroundColor: userColor,
                                            top: '12px',
                                        }}>
                                            {parseAvatarText(fullName)}
                                        </Avatar> :
                                        this.alertIcon(noti)
                                }

                                <div className={'noti-status'}>
                                    {
                                        this.parseNotiHeader(fullName, noti)
                                    }
                                    <p style={{
                                        float: 'right', right: '0px', fontStyle: 'italic',
                                        position: 'absolute', top: '0px',
                                    }}>
                                        {parseTimeFromNow(noti.createdOn)}
                                    </p>
                                </div>
                                <div className={'noti-content'}>
                                    {this.parseNotiContent(noti)}
                                </div>
                            </Menu.Item>
                        })
                        : <Menu.Item key={'null'} disabled className={'noti-item-null'}>
                            <p style={{textAlign: 'center', width: '100%'}}>
                                Không có thông báo nào cả!
                            </p>
                        </Menu.Item>
                }
            </Menu>
        );


        return (
            <div style={{
                float: 'right',
                position: 'relative',
                top: '10px',
                zIndex: 150,
                marginRight: '15px'
            }}>
                <Badge
                    showZero
                    count={this.props.notiCount ? this.props.notiCount : 0}
                    style={{top: '-2px', left: '33px', fontWeight: 600}}
                >
                    <Dropdown
                        placement={'bottomLeft'}
                        trigger={['click']}
                        overlay={notiView}
                        onVisibleChange={(visible) => {
                            this.setState({
                                visible: visible,
                                layoutPointer: !visible
                            });
                        }}
                        visible={this.state.visible}
                    >
                        <Button
                            style={{
                                border: 'none',
                                fontSize: '19px',
                                width: '40px',
                                height: '40px',
                                zIndex: 101,
                                background: 'transparent'
                            }}
                            shape="circle"
                            icon="notification"/>
                    </Dropdown>
                </Badge>
            </div>
        );
    }
}

Notification.propTypes = {
    notifications: PropTypes.array,
    notiCount: PropTypes.number,
    usersMap: PropTypes.object,
    issuesMap: PropTypes.object,
    token: PropTypes.string,
};

Notification.defaultProps = {
    notifications: [],
    notiCount: 0,
    usersMap: Map({}),
    issuesMap: Map({}),
    token: ''
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/notification/notification.js